import React, { Component } from 'react';
import ReactGA from 'react-ga';
import { Icon, Menu, Sticky } from 'semantic-ui-react';

export class IconMenu extends Component {
  state = {
  	activeItem: "aboutMe"
  }

  handleItemClick = (e, { name }) => {
    let element = document.getElementById(name);
    this.setState({ activeItem: name });
    element.scrollIntoView({
      behavior: 'smooth',
      inline: 'start'
    });

    ReactGA.set({ page: window.location.pathname + `#{name}` });
    ReactGA.pageview(window.location.pathname + `#{name}`);
  }

  render() {
    const { activeItem } = this.state;
    const { contextRef } = this.props;

    return (
      <Sticky offset={10} context={contextRef}>
        <Menu className="icon-menu" compact icon='labeled' vertical>
          <Menu.Item name='aboutMe' active={activeItem === 'aboutMe'} onClick={this.handleItemClick}>
            <Icon size='huge' name='user circle outline'/>
            About me
          </Menu.Item>

          <Menu.Item name='experience' active={activeItem === 'experience'} onClick={this.handleItemClick}>
            <Icon size='huge' name='briefcase' />
            Experience
          </Menu.Item>

          <Menu.Item name='education' active={activeItem === 'education'} onClick={this.handleItemClick}>
            <Icon size='huge' name='certificate' />
            Education
          </Menu.Item>

          {/* <Menu.Item name='blog' active={activeItem === 'blog'} onClick={this.handleItemClick}>
            <Icon size='huge' name='compose' />
            Blog
          </Menu.Item> */}

          <Menu.Item name='contactMe' active={activeItem === 'contactMe'} onClick={this.handleItemClick}>
            <Icon size='huge' name='mail outline' />
            Contact Me
          </Menu.Item>
        </Menu>
      </Sticky>
    )
  }
}

export default IconMenu;



// WEBPACK FOOTER //
// ./src/components/IconMenu.js